/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./product-material-event.vue?vue&type=template&id=7906b487&scoped=true&"
import script from "./product-material-event.vue?vue&type=script&lang=ts&"
export * from "./product-material-event.vue?vue&type=script&lang=ts&"
import style0 from "./product-material-event.vue?vue&type=style&index=0&id=7906b487&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7906b487",
  null
  
)

export default component.exports